import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardTitle,
    CardSubtitle,
    Container,
    FormGroup,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";

import { AvForm, AvField} from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-tagsinput/react-tagsinput.css";
import showNotification from "../../../helpers/show_notification";
import { postSubmitForm } from "../../../helpers/forms_helper";
import TagsInput from "react-tagsinput";
import { InsertEquipment, loadAllEquipments } from "../../../store/actions";


const AddEquipments = (props) => {
    const refNewCategoryForm = useRef(null);
    const refNewUnitForm = useRef(null);
    const refContainer = useRef(null);
    const dispatch = useDispatch();
    const equipments = useSelector(store=>store.Equipment.equipments)
    useEffect(()=>{
      dispatch(loadAllEquipments())
    },[])
    
    useEffect(() => {
        loadAllCategories();
        loadAllUnits();
      }, []);

    const [allCategories, setAllCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [allSubCategories, setAllSubCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState();
    const loadAllCategories = async () => {
        let url = process.env.REACT_APP_BASEURL + "equipmentcategories/getall";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
          setAllCategories(response.data);
        } else {
          showNotification(response.message, "Error");
        }
    };

    const [allUnits, setAllUnits] = useState([])
    const loadAllUnits = async () => {
        let url = process.env.REACT_APP_BASEURL + "equipmentunits/getall";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
          setAllUnits(response.data);
        } else {
          showNotification(response.message, "Error");
        }
    };  
    const [newCategoryModal, setNewCategoryModal] = useState();
    const [newSubCategories, setNewSubCategories] = useState([]);

    const handleAddNewCategory = async (e, v) => {
      try {
        const object = {
          category: v.name,
          sub_category: newSubCategories,
        };
        let url = process.env.REACT_APP_BASEURL + "equipmentcategories/insert";
        let response = await postSubmitForm(url, object);
        if (response.status === 1) {
          loadAllCategories();
          setSelectedCategory(v.name);
          setAllSubCategories(newSubCategories);
          setNewSubCategories([]);
          setNewCategoryModal(!newCategoryModal);
          refNewCategoryForm.current.reset();
        } else {
          showNotification(response.message, "Error");
        }
      } catch (error) {
        showNotification(error.message, "Error");
      }
    };
  
    const [newSubCategoryModal, setNewSubCategoryModal] = useState();
    const handleAddNewSubCategory = async (e, v) => {
      try {
        const object = {
          category: selectedCategory,
          sub_category: v.name,
        };
        let url =
          process.env.REACT_APP_BASEURL + "equipmentcategories/insert_subcategory";
        let response = await postSubmitForm(url, object);
        if (response.status === 1) {
          loadAllCategories();
          let all_sub_cat = [...allSubCategories];
          all_sub_cat.push(v.name);
          setAllSubCategories(all_sub_cat);
          setSelectedSubCategory(v.name);
          setNewSubCategoryModal(!newSubCategoryModal);
        } else {
          showNotification(response.message, "Error");
        }
      } catch (error) {
        showNotification(error.message, "Error");
      }
    };

    const [newUnitModal, setNewUnitModal] = useState();
    const [selectedUnit, setSelectedUnit] = useState()
    const handleAddNewUnit = async (e, v) => {
        try {
            const object = {
                unit: v.name,
            };
            
            let url = process.env.REACT_APP_BASEURL + "equipmentunits/insert";
            let response = await postSubmitForm(url, object);
            if (response.status === 1) {
                setSelectedUnit(v.name);
                setNewUnitModal(false)
                refNewUnitForm.current.reset();
            } else {
                showNotification(response.message, "Error");
            }
        } catch (error) {
            showNotification(error.message, "Error");
        }
    };

    const handleValidSubmit = async (e, v) => {
        try {
    
            let payload = {...v }
            // console.log(payload,"PL");
            // dispatch(InsertEquipment(payload))
            // return
            let url = process.env.REACT_APP_BASEURL + "equipments/insert";
            let response = await postSubmitForm(url, payload);
            if (response.status === 1) {
                showNotification(response.message, "Success");
                refContainer.current.reset();
                dispatch(loadAllEquipments())
            } else {
                showNotification(response.message, "Error");
            }
        } catch (error) {
            showNotification(error.message, "Error");
        }
    };

    const columns = [
        {
            text: "#",
            dataField: "_id",
            formatter: (cell, row, rowIndex) => {
                return rowIndex + 1
            },
            headerStyle: (colum, colIndex) => {
                return { width: "2%" };
            },
            //   hidden: true,
        },
        {
          text: props.t("Name"),
          dataField: "name",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "15%" };
          },
        },
      
        {
          dataField: "category",
          text: props.t("Category"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
          dataField: "sub_category",
          text: props.t("Sub-Category"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        {
            dataField: "brand",
            text: props.t("Brand"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
          {
            dataField: "cost_price",
            text: props.t("Cost Price"),
            sort: true,
            formatter:(cel,row)=>{
                return (row.cost_price+"/"+row.unit)
              },
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
        
        {
          dataField: "threshold",
          text: props.t("Threshold"),
          sort: true,
          formatter:(cel,row)=>{
            return (row.threshold+" "+row.unit)
          },
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        
        
    ];
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={props.t("Equipments")}
                        breadcrumbItem={props.t("Add Equipments")}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                                        <CardTitle>{props.t("Add Equipment")}</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            {props.t(
                                                "Enter the following details to add a equipment"
                                            )}
                                        </CardSubtitle>
                                        <Row>
                                            <Col lg={6}>
                                                <AvField
                                                    name="name"
                                                    label={props.t("Name")}
                                                    placeholder={props.t("Enter Equipment Name")}
                                                    type="text"
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Name cannot be empty"),
                                                        },
                                                    }}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="category"
                                  label={props.t("Category")}
                                  type="select"
                                  value={selectedCategory}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Category cannot be empty"
                                  )}
                                  onChange={(e) => {
                                    setSelectedCategory(e.target.value);
                                    if (e.target.value) {
                                      var categories = JSON.parse(
                                        JSON.stringify(allCategories)
                                      );
                                      let arr = categories.filter(
                                        (category) =>
                                          category.category === e.target.value
                                      );
                                      setAllSubCategories(arr[0].sub_category);
                                    } else {
                                      setAllSubCategories([]);
                                    }
                                  }}
                                >
                                  <option value="">
                                    {props.t("--Select Category--")}
                                  </option>
                                  {allCategories &&
                                    allCategories.map((category) => {
                                      return (
                                        <option value={category.category}>
                                          {category.category}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Button
                                  className="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {
                                    setNewCategoryModal(!newCategoryModal);
                                  }}
                                >
                                  <i className="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6}>
                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="sub_category"
                                  label={props.t("Sub-Category")}
                                  type="select"
                                  required
                                  errorMessage={props.t(
                                    "Sub-Category cannot be empty"
                                  )}
                                  value={selectedSubCategory}
                                >
                                  <option value="">
                                    {props.t("--Select Sub-Category--")}
                                  </option>
                                  {allSubCategories &&
                                    allSubCategories.map((subcategory) => {
                                      return (
                                        <option value={subcategory}>
                                          {subcategory}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Button
                                  className="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {
                                    if (selectedCategory) {
                                      setNewSubCategoryModal(
                                        !newSubCategoryModal
                                      );
                                    } else {
                                      showNotification(
                                        props.t("Select a category first!"),
                                        props.t("Error")
                                      );
                                    }
                                  }}
                                >
                                  <i className="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6}>
                            <Row>
                              <Col lg={9}>
                                <AvField
                                  name="unit"
                                  label={props.t("Unit")}
                                  type="select"
                                  required
                                  errorMessage={props.t(
                                    "Unit cannot be empty"
                                  )}
                                  value={selectedUnit}
                                >
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {allUnits &&
                                    allUnits.map((unit) => {
                                      return (
                                        <option value={unit.unit}>
                                          {unit.unit}
                                        </option>
                                      );
                                    })}
                                </AvField>
                              </Col>
                              <Col lg={3}>
                                <Label>&nbsp;</Label>
                                <br />
                                <Button
                                  className="btn btn-success waves-effect waves-light btn-sm"
                                  onClick={() => {                   
                                      setNewUnitModal(
                                        !newUnitModal
                                      );
                                   
                                  }}
                                >
                                  <i className="mdi mdi-file-plus"></i>{" "}
                                  {props.t("Add New")}
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6}>
                                <AvField
                                  name="brand"
                                  label={props.t("Brand")}
                                  type="text"
                                  placeholder={props.t("Enter brand name ")}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Brand cannot be empty"
                                  )}
                    
                                >
                               
                                </AvField>
                          </Col>
                          <Col lg={6}>
                            <AvField
                              name="cost_price"
                              label={props.t("Cost Price")}
                              placeholder={props.t("Enter Cost Price")}
                              type="number"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: props.t(
                                    "Cost Price cannot be empty."
                                  ),
                                },
                                pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: props.t(
                                    "Only numbers are allowed."
                                  ),
                                },
                              }}
                              
                
                            />
                          </Col>
                          <Col lg={6}>
                            <AvField
                              name="threshold"
                              label={props.t("Threshold Qty.")}
                              placeholder={props.t(
                                "Enter Threshold Quantity"
                              )}
                              type="number"
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: props.t(
                                    "Threshold cannot be empty."
                                  ),
                                },
                                pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: props.t(
                                    "Only numbers are allowed."
                                  ),
                                },
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <AvField
                              name="remarks"
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>

                                           
                                       
                                           
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <hr />
                                                <FormGroup className="mb-0 text-center">
                                                    <div>
                                                        <Button
                                                            type="submit"
                                                            color="primary"
                                                            className="mr-1"
                                                        >
                                                            {props.t("Submit")}
                                                        </Button>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>{props.t("Existing Equipments")} </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {props.t("View all your existing equipments here")}
                                    </CardSubtitle>
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="_id"
                                        data={equipments && equipments}
                                        columns={columns}
                                        noDataIndication={props.t("No equipments to display.")}
                                        striped
                                        hover
                                        condensed
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                {/* Category Modal  */}
                  <Modal
                    size="md"
                    isOpen={newCategoryModal}
                    toggle={() => setNewCategoryModal(!newCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewCategoryModal(!newCategoryModal)}
                    >
                      {props.t("Add new category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Category")}
                                      placeholder={props.t(
                                        "Enter Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>
                                      {props.t("Sub-Category Name")}
                                    </Label>{" "}
                                    ({props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubCategories}
                                      onChange={(tags) => {
                                        setNewSubCategories(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* subcategory Modal */}
                  <Modal
                    size="md"
                    isOpen={newSubCategoryModal}
                    toggle={() => setNewSubCategoryModal(!newSubCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() =>
                        setNewSubCategoryModal(!newSubCategoryModal)
                      }
                    >
                      {props.t("Add new sub-category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewSubCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Sub-Category")}
                                      placeholder={props.t(
                                        "Enter Sub-Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* Add Units Modal  */}
                    <Modal
                    size="md"
                    isOpen={newUnitModal}
                    toggle={() => setNewUnitModal(!newUnitModal)}
                  >
                    <ModalHeader
                      toggle={() =>
                        setNewUnitModal(!newUnitModal)
                      }
                    >
                      {props.t("Add new unit")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                    handleAddNewUnit(e, v);
                                }}
                                ref={refNewUnitForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Unit")}
                                      placeholder={props.t(
                                        "Enter Unit Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(connect(null, {})(withNamespaces()(AddEquipments)));
